var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: !_vm.dataForm.id ? "新增" : "修改",
        "close-on-click-modal": false,
        visible: _vm.visible,
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
        opened: _vm.initEditor,
        closed: _vm.closeDig,
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "dataForm",
          attrs: {
            model: _vm.dataForm,
            rules: _vm.dataRule,
            "label-width": "108px",
          },
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "数据集编号：", prop: "code" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "数据集编号" },
                        model: {
                          value: _vm.dataForm.code,
                          callback: function ($$v) {
                            _vm.$set(_vm.dataForm, "code", $$v)
                          },
                          expression: "dataForm.code",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "是否为列表：", prop: "hasMultiLine" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "是否为列表" },
                          model: {
                            value: _vm.dataForm.hasMultiLine,
                            callback: function ($$v) {
                              _vm.$set(_vm.dataForm, "hasMultiLine", $$v)
                            },
                            expression: "dataForm.hasMultiLine",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "否", value: false },
                          }),
                          _c("el-option", {
                            attrs: { label: "是", value: true },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "SQL语句：", prop: "sqlClause" } },
                    [
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.dataForm.sqlClause,
                            expression: "dataForm.sqlClause",
                          },
                        ],
                        ref: "sqlEditor",
                        staticClass: "codesql",
                        attrs: { rows: "20", placeholder: "SQL语句" },
                        domProps: { value: _vm.dataForm.sqlClause },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.dataForm,
                              "sqlClause",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  _vm.visible = false
                },
              },
            },
            [_vm._v("取消")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function ($event) {
                  return _vm.dataFormSubmit()
                },
              },
            },
            [_vm._v("确定")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }